/**
 * Product branding. Every surface must read from this constant (product law:
 * branding is centralized, never hard-coded).
 *
 * Renamed from the working name "BuildLedger" on 2026-08-28. Note what did NOT
 * change with it, deliberately: Postgres role names, browser/device storage
 * keys, and metadata wire keys all still say `buildledger`. They are invisible
 * to users, and renaming a storage key signs every user out.
 */
export const BRAND = {
    /** Product name, as displayed to a human. */
    name: 'Job Site AI',
    /**
     * Filename/URL-safe form. Use this — NOT `name.toLowerCase()` — anywhere the
     * value becomes a filename or a path segment, because the display name
     * contains spaces.
     */
    slug: 'job-site-ai',
    /** Short descriptor used on placeholder/marketing surfaces. */
    tagline: 'Estimating and proposals for every trade',
    /**
     * The in-product assistant's name, as displayed to a human.
     *
     * Renamed from "Tony" on 2026-09-14. As with the product rename, only what a
     * user sees changed: the `tony` API module and `/api/v1/tony/*` routes, the
     * `Tony*` schemas, the mobile `(tabs)/tony` route and the `bl-tony-*` classes
     * keep the old word on purpose — a phone still running an older build calls
     * those routes, and none of it is visible.
     */
    assistantName: 'Joe',
};
//# sourceMappingURL=brand.js.map